// Settings actions
import axios from 'axios';
import types from '../../types';
/* eslint-disable */
export default {
  // shops
  [types.GET_SHOPS]: async (context) => {
    try {
      await axios.get('shop').then((res) => {
        context.commit('STORE_SHOPS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_SHOP]: async (context, payload) => {
    try {
      await axios.post('shop', payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_SHOP]: async (context, payload) => {
    try {
      await axios.put(`shop/${payload.id}`, payload.form);
    } catch (err) {
      console.error(err);
    }
  },

  // Shipping methods
  [types.GET_SHIPPING_METHODS]: async (context) => {
    try {
      await axios.get('shipping-method').then((res) => {
        context.commit('STORE_SHIPPING_METHODS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_SHIPPING_METHOD]: async (context, payload) => {
    try {
      await axios.post('shipping-method', payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_SHIPPING_METHOD]: async (context, payload) => {
    try {
      await axios.put(`shipping-method/${payload.id}`, payload.form);
    } catch (err) {
      console.error(err);
    }
  },
};
